import { computed, Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class IdleService {
  readonly remainingTime: WritableSignal<number> = signal(0);
  readonly toggleIdleModal = computed(() => this.remainingTime() > 0 && this.remainingTime() < 61);

  reset(): void {
    this.remainingTime.set(0);
  }
}
